(function (angular) {
    'use strict';

    angular.module('app')
        .service('PagesApi', pagesResource);

    pagesResource.$inject = [
        'settings',
        '$resource'
    ];

    function pagesResource(
        settings,
        $resource
    ) {

        /**
         * Adds extra methods and values. Expects "this" to be bound to an page object
         * @return {this}
         */
        function transform() {
            // add "url" property
            this.url = '/pages/' + this.slug;

            // add "feature" property to system pages that are managed by features
            if (this.type === 'page' && this.is_system === 1) {
                this.feature = this.slug.replace('feature-', '');

                // override url
                this.url = '/' + this.feature;
            }

            return this;
        }

        // Create the resource
        var resource = $resource(settings.apiBase + '/posts/:id', {}, {
            get: {
                method: 'GET',
                params: {
                    type: 'page'
                },
                responseType: 'json',
                transformResponse: function (response) {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }

                    if (Array.isArray(response.data)) {
                        angular.forEach(response.data, function (page) {
                            transform.call(page);
                        });
                    } else {
                        if (response.data) {
                            transform.call(response.data);
                        }
                    }

                    return response;
                }
            },
            update: {
                method: 'PUT',
                responseType: 'json',
                params: {
                    id: '@id'
                },
                transformResponse: function (response) {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }

                    if (response.data) {
                        transform.call(response.data);
                    }
                    return response;
                }
            }
        });
        resource.prototype.transform = transform;

        return resource;
    }

}(angular));
